import React from 'react';
import { ButtonIcon } from '@storebrand-digital/pretzel';
import styles from './DropdownFilter.module.css';
import { HeaderProps } from './types';

const DropdownFilterHeader: React.FC<HeaderProps> = ({
  heading,
  isMobile,
  onClose,
}) => {
  return (
    <div className={`${styles.dropdownContentHeader} font-body-demibold`}>
      {heading}
      {isMobile && (
        <ButtonIcon
          label="Close"
          aria-label="Close"
          icon="x"
          size="large"
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default DropdownFilterHeader;
